import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { createVuetify } from 'vuetify';

import { messages } from './Locale/getTexts';
import SliderContentBlockApp from './SliderContentBlockApp.vue';

const sliderContentBlockApps = document.getElementsByClassName(
  'SliderContentBlockApp',
);
if (sliderContentBlockApps.length !== 0) {
  for (let i = 0; i < sliderContentBlockApps.length; i++) {
    const sliderContentBlockApp = sliderContentBlockApps[i];
    const locale = sliderContentBlockApp.getAttribute('data-locale') || 'no';
    const i18n = createI18n({
      legacy: false,
      locale,
      fallbackLocale: 'no',
      messages,
    });

    const vuetify = createVuetify({
      theme: false,
    });

    const app = createApp(SliderContentBlockApp, {
      locale: locale,
      startPageId: sliderContentBlockApp.getAttribute('data-start-page-id'),
      contentId: sliderContentBlockApp.getAttribute('data-content-id'),
    });
    app.use(vuetify);
    app.use(i18n);

    app.mount(sliderContentBlockApp);
  }
}
